/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { Fragment, MouseEvent, ReactElement, useContext, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer'
import LeafletComponent from './LeafletComponent'
import { FeaturedArticleShowContext } from '../../FeaturedArticles/Show'
import { genJyuuGothicBold } from '../../fonts/FontFace'
import { LeafletsComponentProp } from '../../types'

type Props = {
  component: LeafletsComponentProp
  key: number
}

function LeafletsComponent({ component }: Props): ReactElement {
  const [viewMore, setViewMore] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
  const { ref, inView } = useInView({ triggerOnce: true })
  const featuredArticleShowContext = useContext(FeaturedArticleShowContext)

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    inView &&
      featuredArticleShowContext &&
      featuredArticleShowContext.logFeaturedArticleEvent({
        event: 'leaflets_component_imp',
      })
  }, [inView, featuredArticleShowContext])

  return (
    <Fragment>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
      <div ref={ref} css={leafletsComponentStyle} className="leaflets_component">
        {component.title && (
          <h2 css={titleStyle(component.titleColor)}>
            {component.title.split(/\n/).map((leadElement, i) => (
              <Fragment key={i}>
                {leadElement}
                <br />
              </Fragment>
            ))}
          </h2>
        )}
        <ul css={leafletsWrapperStyle}>
          {component.leaflets.map((leaflet, i) => (
            <LeafletComponent key={i} leaflet={leaflet} order={i} viewMore={viewMore} />
          ))}
        </ul>
        {!viewMore && component.leaflets.length > 4 && (
          <a
            css={viewMoreStyle}
            onClick={(event: MouseEvent<HTMLAnchorElement>) => {
              event.preventDefault()
              setViewMore(true)
            }}
          >
            もっと見る
          </a>
        )}
      </div>
    </Fragment>
  );
}

const leafletsComponentStyle = css`
  margin: 24px 0;
  padding: 24px 12px 0 12px;
`

const titleStyle = (titleColor: string) => css`
  ${genJyuuGothicBold}
  font-size: 20px;
  color: ${titleColor};
  text-align: center;
  margin-top: 0;
  line-height: 30px;
`

const leafletsWrapperStyle = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
`

const viewMoreStyle = css`
  display: flex;
  text-decoration: none;
  font-size: 14px;
  padding: 18px;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 4px;
  margin: 12px 0;
  color: rgba(0, 0, 0, 0.54);
`

export default LeafletsComponent
